import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    redirect: { name: "usa" },
  },
  {
    path: "/usa",
    name: "usa",
    component: () => import(/* webpackChunkName: "usa" */ "../views/DisplayUsa.vue"),
  },
  {
    path: "/RD",
    name: "rd",
    component: () => import(/* webpackChunkName: "usa" */ "../views/DisplayRD.vue"),
  },
  {
    path: "/nyh",
    name: "nyh",
    component: () => import(/* webpackChunkName: "usa" */ "../views/NyhForm.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
